import { render, staticRenderFns } from "./shoppingguidenotification.vue?vue&type=template&id=b2cccf1c&scoped=true"
import script from "./shoppingguidenotification.vue?vue&type=script&lang=js"
export * from "./shoppingguidenotification.vue?vue&type=script&lang=js"
import style0 from "./shoppingguidenotification.vue?vue&type=style&index=0&id=b2cccf1c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2cccf1c",
  null
  
)

export default component.exports